<template>
    <div v-if="chipsItems.length" class="filter_chips">
        <div class="filter_chips-list">
            <div v-for="item in chipsItems" :key="item.id">
                <div
                    class="filter_chips-list-item button button-blue button-round"
                    :class="{ 'filter_chips-list-item--is-exclude': item.isExclude }"
                >
                    <span>{{ item.type === 'tag' ? `#${item.field_value}` : item.field_value }}</span>
                    <button @click="removeFilter(item)" class="filter_chips-list-item-close"></button>
                </div>
                <div
                    v-if="isMobile && item.type === 'tag' && chipsItems.length > 1"
                    :key="`tag-line-${item.id}`"
                    class="filter_chips-list-item-line"
                ></div>
            </div>
            <button
                v-if="showClearAll"
                class="filter_chips-clear button button-red button-link"
                @click="clearFilters()"
            >
                Очистить все фильтры
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'FilterChips',

    props: {
        chipsItems: {
            type: Array,
            default: () => [],
        },
        showClearAll: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        ...mapGetters(['isMobile']),
    },

    methods: {
        removeFilter(item) {
            this.$emit('removeItem', item);
        },
        clearFilters() {
            this.$emit('clear');
        },
        truncate(text, length, suffix) {
            return text.length > length ? text.substring(0, length) + suffix : text;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem.scss';
@import '~@/styles/mrem.scss';
@import '~@/styles/variables.scss';
@import '~@/styles/buttons_v2.scss';

.filter_chips {
    font-family: $font-montserrat;

    @include on-desktop {
        margin-bottom: rem(40);
    }

    &-list {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;

        &-item {
            display: inline-block;
            padding: mrem(10.5) mrem(42) mrem(10.5) mrem(18);
            margin: 0 mrem(14) mrem(16) 0;
            position: relative;
            cursor: auto;

            font-style: normal;
            font-weight: 400;
            font-size: mrem(16);
            line-height: mrem(18);
            height: auto;
            vertical-align: middle;
            width: auto;
            text-align: left;

            @include on-desktop {
                padding: rem(10.5) rem(42) rem(10.5) rem(18);
                margin: 0 rem(14) rem(16) 0;
                font-size: rem(16);
                line-height: rem(18);
            }

            &--is-exclude {
                color: #db6c61;
                background: #f8f8f8;
                border: 1px solid #db6c61;

                &:hover {
                    background: #f8f8f8 !important;
                }

                .filter_chips-list-item-close {
                    background: url('~@/assets/images/UI/chips/chip-close-red.svg') no-repeat center center;
                    background-size: cover;
                }
            }

            &-close {
                display: block;
                position: absolute;
                top: 50%;
                margin-top: -#{mrem(12)};
                right: mrem(12);
                color: inherit;
                border: none;
                cursor: pointer;
                background: url('~@/assets/images/UI/chips/chip-close.svg') no-repeat center center;
                background-size: cover;
                width: mrem(24);
                height: mrem(24);

                @include on-desktop {
                    margin-top: -#{rem(12)};
                    right: rem(12);
                    width: rem(24);
                    height: rem(24);
                }
            }

            &-line {
                width: 120vh;
                border-top: mrem(2) solid #e3edff;
                margin-bottom: mrem(16);
                margin-left: -10vh;

                @include on-desktop {
                    display: none;
                }
            }
        }
    }

    &-clear {
        --background: #{$color-main-red};
        --background-hover: #{$color-main-red};
        --background-click: #{$color-main-red};

        font-family: $font-main;
        display: inline-block;

        font-style: normal;
        font-weight: 400;
        font-size: mrem(18);
        line-height: mrem(18);
        padding: mrem(10.5) 0;
        width: auto;
        height: mrem(40);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(19);
            padding: 0;
            height: rem(40);
        }
    }
}
</style>
